/* Lo Esencial header chrome: mobile drawer + search overlay toggles */
(function () {
  'use strict';

  function init() {
    var drawer = document.getElementById('mobile-drawer');
    var mobileToggle = document.querySelector('[data-mobile-toggle]');
    var mobileCloses = document.querySelectorAll('[data-mobile-close]');

    if (drawer && mobileToggle) {
      mobileToggle.addEventListener('click', function () {
        openDialog(drawer, mobileToggle);
      });

      mobileCloses.forEach(function (btn) {
        btn.addEventListener('click', function () {
          closeDialog(drawer);
        });
      });
    }

    var overlay = document.getElementById('search-overlay');
    var searchToggles = document.querySelectorAll('[data-search-toggle]');
    var searchCloses = document.querySelectorAll('[data-search-close]');

    if (overlay) {
      searchToggles.forEach(function (btn) {
        btn.addEventListener('click', function (ev) {
          ev.preventDefault();
          openDialog(overlay, btn);
          var input = overlay.querySelector('#search-overlay-input');
          if (input) {
            setTimeout(function () { input.focus(); }, 50);
          }
        });
      });

      searchCloses.forEach(function (btn) {
        btn.addEventListener('click', function () {
          closeDialog(overlay);
        });
      });
    }
  }

  function openDialog(dialog, trigger) {
    if (typeof dialog.showModal === 'function') {
      dialog.showModal();
    } else {
      dialog.setAttribute('open', 'true');
    }
    document.body.style.overflow = 'hidden';
    if (trigger) {
      trigger.setAttribute('aria-expanded', 'true');
    }
    dialog.addEventListener('click', function onBackdrop(ev) {
      if (ev.target === dialog) {
        closeDialog(dialog);
        dialog.removeEventListener('click', onBackdrop);
      }
    });
    dialog.addEventListener('close', function onClose() {
      document.body.style.overflow = '';
      if (trigger) trigger.setAttribute('aria-expanded', 'false');
      dialog.removeEventListener('close', onClose);
    });
  }

  function closeDialog(dialog) {
    if (typeof dialog.close === 'function') {
      dialog.close();
    } else {
      dialog.removeAttribute('open');
    }
    document.body.style.overflow = '';
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
